import OperationLogDrawerTrigger from '@/components/common/OperationLogDrawerTrigger';

export default function SiteModuleDrawerOperationLogExtra({ siteModuleId }) {
    return <OperationLogDrawerTrigger entityId={siteModuleId} entityType="site_module" module="conference" />;
}
